import styled from 'styled-components';

export const StyledSummarySection = (Component) => styled(Component)`
  max-width: 344px;
  border: 1px solid var(--greyMouse);
  padding: 16px;
  margin-top: 16px;

  .price-description-pair {
    display: flex;
    align-items: center;
  }

  .description {
    display: flex;
    align-items: center;
  }

  .price {
    margin-left: auto;
  }

  .divider {
    width: 100%;
    border-bottom: 1px solid var(--greyMouse);
    margin: 16px 0px;
  }

  .margin-bottom {
    margin-bottom: 8px;
  }
`;
